export default "__VITE_PUBLIC_ASSET__c24324f6__"